import { Link, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { FileClock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useSupportAccess } from '@/hooks/useSupportAccess'
import { versionHistoryTargetForPath } from '@/services/shared/versionHistoryApi'

/**
 * Opens the version history on the object the current detail page shows. Meant
 * for the page header's actions; renders nothing for users without support
 * access, or on a page that does not show a saved object.
 */
export function VersionHistoryButton() {
  const { t } = useTranslation()
  const location = useLocation()
  const hasSupportAccess = useSupportAccess()
  const target = versionHistoryTargetForPath(location.pathname)

  if (!hasSupportAccess || !target) return null

  return (
    <Button asChild variant="outline">
      <Link to={`/version-history?${new URLSearchParams(target)}`}>
        <FileClock />
        {t('versionHistory.title')}
      </Link>
    </Button>
  )
}
